<template>
  <div id="app">
    <menu-bar></menu-bar>
    <router-view :key="this.$route.path"/>
  </div>
</template>
​
<script>
import axios from "axios";
import MenuBar from "@/components/MenuBar";

export default {
  name: "App",
  components: {
    MenuBar,
  },
  created() {
    axios.interceptors.response.use(undefined, function(err) {
      return new Promise(function(resolve, response) {
        if (err.status === 401 && err.config && !err.config__isRetryRequest) {
          // if unauthorized error, logout the user
          this.$store.dispatch(AUTH_LOGOUT);
        }
        throw err;
      });
    });
  },
};
</script>
